import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Compass, Search, MessagesSquare, User } from "lucide-react";
import { useAuth } from "../lib/auth";
import { useActivity, openAuth } from "../lib/activity";

export default function MobileNav({ onOpenSearch }) {
  const { user } = useAuth();
  const { totalUnread = 0 } = useActivity() || {};
  const item = "flex-1 flex flex-col items-center justify-center gap-0.5 text-xs font-bold min-h-[56px] relative";
  const cls = ({ isActive }) => `${item} ${isActive ? "text-foreground" : "text-muted-foreground"}`;
  const bar = ({ isActive }) => isActive ? <span className="absolute top-0 left-1/4 right-1/4 h-[3px] bg-[#FFBE06]" /> : null;

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-card border-t border-border flex"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      aria-label="Primary"
      data-testid="mobile-bottom-nav"
    >
      <NavLink to="/" end className={cls} data-testid="mnav-home">{(s) => <>{bar(s)}<Home size={20} />Home</>}</NavLink>
      <NavLink to="/browse" className={cls} data-testid="mnav-explore">{(s) => <>{bar(s)}<Compass size={20} />Explore</>}</NavLink>
      <button onClick={onOpenSearch} className={`${item} text-muted-foreground`} data-testid="mnav-search">
        <span className="w-11 h-11 -mt-5 bg-[#FFBE06] text-[#111111] border border-[#FFBE06] flex items-center justify-center"><Search size={20} /></span>
        Search
      </button>
      {user ? (
        <>
          <NavLink to="/me" className={cls} data-testid="mnav-rooms">
            {(s) => <>{bar(s)}<span className="relative"><MessagesSquare size={20} />{totalUnread > 0 && <span className="badge-count absolute -top-2 -right-3">{totalUnread > 99 ? "99+" : totalUnread}</span>}</span>My rooms</>}
          </NavLink>
          <NavLink to="/me#profile" className={`${item} text-muted-foreground`} data-testid="mnav-profile"><User size={20} />Profile</NavLink>
        </>
      ) : (
        <button onClick={openAuth} className={`${item} text-muted-foreground`} data-testid="mnav-signin"><User size={20} />Sign in</button>
      )}
    </nav>
  );
}
